import {
  Component,
  OnInit,
  Input,
  Output,
  EventEmitter,
  ViewEncapsulation,
  SimpleChanges,
  ViewChild,
  HostListener,
} from "@angular/core";
import { NzCarouselComponent } from "ng-zorro-antd/carousel";
import { AppService } from "src/app/app.service";
import { ChartType } from "../chart-plotter.model";
import { Dictionary } from "src/app/store/models/common_types";
import dayjs from "dayjs";
import { AppState, stateGetter } from "src/app/store/state/app.state";
import { Store } from "@ngrx/store";
import {
  ABS_PERIOD_TYPE,
  CY_PERIOD_BASIS,
  FY_PERIOD_BASIS,
} from "@va/core-library/period-filter";
import { NzMessageService } from "ng-zorro-antd/message";
import {
  VAIconRegistryService,
  greaterThan,
  infoCircle,
  lessThan,
} from "@va/core-library/icons";
@Component({
  selector: "app-chart-popup",
  templateUrl: "./chart-popup.component.html",
  styleUrls: ["./chart-popup.component.scss"],
  encapsulation: ViewEncapsulation.None,
})
export class ChartPopupComponent implements OnInit {
  chartMap: Dictionary<Array<ChartType>>;
  chartCarouselList: Array<ChartType>;
  sortedChartNames: Array<string>;
  effect = "scrollx";
  @Input() showPopup: boolean;
  @Input() beginningStateReferrer: string;
  @Input() closeFeature: string;
  showCarousel: boolean;
  @Input() dataToUse: any;
  @Input() chartType: string;
  @Output() closePopup: EventEmitter<any> = new EventEmitter();
  styleObj: any;
  chartSubType: string;
  chartSubTypeDisplay: string;
  defaultData;
  selectedValue: string;
  periodSwitch = "";
  @ViewChild(NzCarouselComponent)
  chartCarousel: NzCarouselComponent;
  modalWidth;
  modalHeight;
  stdDev = "";
  consensusValue = "";
  displayData: any = {};
  displayDataSet = false;
  plotType = "Data";
  tableData: any = {};
  orignalPeriod;
  logSwitch = false;
  startDate;
  endDate;
  displayPeriod;
  displayOtherPeriod;
  xData: any = [];
  isStockPriceChecked = false;
  hasAccessToStockPrice = true;
  currentYear = new Date().getFullYear();
  stockPriceData = {
    "revision-daily": undefined,
    "revision-monthly": undefined,
  };
  dateFormatPattern = "DD MMM YYYY";

  constructor(
    private appService: AppService,
    private message: NzMessageService,
    private store: Store<AppState>,
    private iconRegistry: VAIconRegistryService,
  ) {
    this.iconRegistry.registerIcons([infoCircle, lessThan, greaterThan]);
  }
  ngOnInit() {
    this.chartMap = {};
    this.chartCarouselList = [];
    this.sortedChartNames = [];
    this.sizeChartChange();
    this.store
      .select(stateGetter("globalHeader", "globalSettings"))
      .subscribe((data: any) => {
        this.hasAccessToStockPrice = data.hasMarketDataAccess;
      });
  }
  @HostListener("window:resize", [])
  sizeChartChange() {
    const windowSize = {
      width: window.innerWidth,
      height: window.innerHeight,
    };
    if (windowSize.width >= 1920) {
      this.modalWidth = "1366px";
      this.modalHeight = "725px";
    } else if (windowSize.width >= 1336) {
      this.modalWidth = "1019px";
      this.modalHeight = "582px";
    } else {
      this.modalWidth = "800px";
      this.modalHeight = "407px";
    }
    this.styleObj = {
      height: this.modalHeight,
    };
  }
  ngOnChanges(changes: SimpleChanges) {
    //if (changes.future) {
    if (changes.showPopup && changes.showPopup.currentValue === true) {
      this.setDefaults();
    }
    setTimeout(() => {
      this.showCarousel = this.showPopup;
      if (this.showCarousel) {
        setTimeout(() => {
          const slideIndex = this.chartCarouselList.findIndex(
            (carouselChart) => {
              return carouselChart.value === this.selectedValue;
            },
          );
          this.chartCarousel.goTo(Number(slideIndex));
        }, 100);
      }
    }, 100); //}
  }

  handleCancel() {
    this.showPopup = false;
    this.showCarousel = false;
    this.plotType = "Data";
    let beginningStateReferrer = "";
    if (this.chartType === "revision" && this.chartSubType === "daily") {
      beginningStateReferrer = "Chart_Revisions_Source_DailyLTM";
    } else if (this.chartType === "distribution") {
      beginningStateReferrer = "Chart_Distribution_Waterfall";
    } else if (this.chartType === "trend") {
      beginningStateReferrer = "Chart_Trends_Bar";
    }
    const extraData = {
      period: this.dataToUse.period,
      line_id: this.dataToUse.dapparamId.toString(),
      page_url: window.location.href,
      beginning_state_referrer: beginningStateReferrer,
    };
    this.appService.logUserAction(
      {},
      this.dataToUse.ticker,
      this.dataToUse.cut,
      this.closeFeature,
      extraData,
      "",
      "Chart_Close",
    );
    this.stockPriceData = {
      "revision-daily": undefined,
      "revision-monthly": undefined,
    };
    if (this.isStockPriceChecked) {
      this.isStockPriceChecked = false;
    }
    this.closePopup.emit();
  }

  setDefaults() {
    const sourceListHasConsensus =
      this.dataToUse.sourceList &&
      this.dataToUse.sourceList.findIndex((s) => {
        return s.value.toLowerCase() === "consensus";
      }) !== -1;
    this.dataToUse.selectedRevisionSources = [this.dataToUse.source];
    this.dataToUse.selectedSurpriseSources = [this.dataToUse.source];
    if (sourceListHasConsensus === true) {
      this.dataToUse.revisionSourceList = {
        headerText: "Source",
        list: [
          { label: "High Broker", value: "High", checked: false },
          { label: "Low Broker", value: "Low", checked: false },
        ].concat(this.dataToUse.sourceList),
      };
      this.dataToUse.surpriseSourceList = {
        headerText: "Source",
        maxLimit: 4,
        list: [].concat(this.dataToUse.sourceList),
      };
    } else {
      this.dataToUse.revisionSourceList = {
        headerText: "Source",
        list: [
          { label: "Consensus", value: "Consensus", checked: true },
          { label: "High Broker", value: "High", checked: false },
          { label: "Low Broker", value: "Low", checked: false },
        ].concat(this.dataToUse.sourceList),
      };
      this.dataToUse.surpriseSourceList = {
        headerText: "Source",
        maxLimit: 4,
        list: [
          { label: "Consensus", value: "Consensus", checked: true },
        ].concat(this.dataToUse.sourceList),
      };
    }
    this.defaultData = {
      ...this.dataToUse,
      showRevisionSourceList: false,
      showSurpriseSourceList: false,
      peersList: {
        headerText: "Peers",
        list: this.dataToUse.peersList || [],
      },
      showPeersList: false,
      displayDataSet: false,
    };
    this.orignalPeriod = this.dataToUse.period;
    if (
      this.dataToUse.source &&
      this.dataToUse.source.toLowerCase() !== "consensus" &&
      this.dataToUse.source.toLowerCase() !== "va actuals"
    ) {
      this.dataToUse.selectedRevisionSources.push("Consensus");
      if (this.dataToUse.source.toLowerCase() === "filings") {
        this.dataToUse.selectedSurpriseSources = ["Consensus"];
      } else {
        this.dataToUse.selectedSurpriseSources.push("Consensus");
      }
    }
    switch (this.chartType.toLowerCase()) {
      case "distribution":
        this.chartSubType =
          this.defaultData.cut === "SCH" ? "range" : "analysis";
        break;
      case "trend":
        this.chartSubType = "bar";
        break;
      case "revision":
        this.chartSubType = "daily";
        break;
      case "revision-peer":
        this.chartType = "revision";
        this.chartSubType = "dailypeers";
        break;
      case "surprise":
        this.chartSubType = "analysis";
        break;
      default:
        this.chartSubType = "";
    }
    this.chartMap = {};
    this.chartCarouselList = [];
    this.sortedChartNames = [];

    const otherPeriodExist =
      this.dataToUse.otherPeriod === "LTM" ||
      this.dataToUse.otherPeriod === "NTM" ||
      this.dataToUse.otherPeriod === "STM";
    if (
      this.dataToUse.calendarization &&
      this.dataToUse.isValuationRatio === true
    ) {
      if (!otherPeriodExist) {
        this.addChartToList("trend-bar");
      }
      if (
        this.defaultData.source &&
        this.defaultData.source.toLowerCase() !== "filings"
      ) {
        this.addChartToList("revision-daily");
        this.addChartToList("revision-monthly");
      }

      //Since Revision Analysis Chart API is not consumed in dedicated charts, no calendarisation done for that API. Hence we will not show this chart option for CY or rolling periods
      // if (this.defaultData.forecast !== false) {
      //   this.addChartToList("revision-analysis");
      // }
    } else if (
      this.dataToUse.otherPeriod === "LTM" ||
      this.dataToUse.otherPeriod === "NTM" ||
      this.dataToUse.otherPeriod === "STM"
    ) {
      this.addChartToList("revision-daily");
      this.addChartToList("revision-monthly");
    }

    //CACC-4699 - In case of FY and absolute, we will follow the same old logic. NOTHING CHANGES.
    else if (
      this.dataToUse.calendarization &&
      !(
        this.dataToUse.basisType === FY_PERIOD_BASIS.id &&
        this.dataToUse.periodType === ABS_PERIOD_TYPE.dataId
      )
    ) {
      if (this.dataToUse.basisType === CY_PERIOD_BASIS.id) {
        this.addChartToList("trend-bar");
        if (
          this.defaultData.source &&
          this.defaultData.source.toLowerCase() !== "filings"
        ) {
          this.addChartToList("revision-daily");
          this.addChartToList("revision-monthly");
        }

        //Since Revision Analysis Chart API is not consumed in dedicated charts, no calendarisation done for that API. Hence we will not show this chart option for CY or rolling periods
        // if (this.defaultData.forecast !== false) {
        //   this.addChartToList("revision-analysis");
        // }
      }

      //Hanlding FY
      else {
        if (this.dataToUse.periodType !== ABS_PERIOD_TYPE.dataId) {
          this.addChartToList("trend-bar");
          if (
            this.defaultData.source &&
            this.defaultData.source.toLowerCase() !== "filings"
          ) {
            this.addChartToList("revision-daily");
            this.addChartToList("revision-monthly");
          }

          //Since Revision Analysis Chart API is not consumed in dedicated charts, no calendarisation done for that API. Hence we will not show this chart option for CY or rolling periods
          // if (this.defaultData.forecast !== false) {
          //   this.addChartToList("revision-analysis");
          // }
        } else {
          console.error("Not supposed to be here");
        }
      }
    } else {
      if (
        this.defaultData.source &&
        this.defaultData.source.toLowerCase() === "filings"
      ) {
        this.addChartToList("trend-bar");
        this.addChartToList("surprise-analysis");
        this.addChartToList("surprise-line");
      } else if (
        this.defaultData.source &&
        this.defaultData.source.toLowerCase() === "va actuals"
      ) {
        this.addChartToList("trend-bar");
        this.addChartToList("revision-daily");
        this.addChartToList("revision-monthly");

        // if (this.defaultData.isPeers) {
        //   this.addChartToList("revision-dailypeers");
        //   this.addChartToList("revision-monthlypeers");
        // }
        this.addChartToList("surprise-analysis");
      } else if (this.defaultData.cut === "NMV") {
        if (
          this.defaultData.source &&
          this.defaultData.source.toLowerCase() === "consensus"
        ) {
          this.addChartToList("distribution-analysis");
          this.addChartToList("distribution-range");
        }

        this.addChartToList("trend-bar");
        this.addChartToList("revision-daily");
        this.addChartToList("revision-monthly");
        if (this.defaultData.forecast !== false) {
          this.addChartToList("revision-analysis");
        }

        // if (this.defaultData.isPeers) {
        //   this.addChartToList("revision-dailypeers");
        //   this.addChartToList("revision-monthlypeers");
        // }

        if (this.defaultData.forecast === false) {
          this.addChartToList("surprise-analysis");
          this.addChartToList("surprise-line");
        }
      } else if (this.defaultData.cut === "STD") {
        if (
          this.defaultData.source &&
          this.defaultData.source.toLowerCase() === "consensus"
        ) {
          this.addChartToList("distribution-analysis");
          this.addChartToList("distribution-range");
        }
        this.addChartToList("trend-bar");
        this.addChartToList("revision-daily");
        this.addChartToList("revision-monthly");
        if (this.defaultData.forecast !== false) {
          this.addChartToList("revision-analysis");
        }

        if (this.defaultData.forecast === false) {
          this.addChartToList("surprise-analysis");
          this.addChartToList("surprise-line");
        }
      } else if (this.defaultData.cut === "SCH") {
        if (
          this.defaultData.source &&
          this.defaultData.source.toLowerCase() === "consensus"
        ) {
          this.addChartToList("distribution-range");
        }
        this.addChartToList("trend-bar");
        this.addChartToList("revision-daily");
        this.addChartToList("revision-monthly");
        if (this.defaultData.forecast !== false) {
          this.addChartToList("revision-analysis");
        }

        if (this.defaultData.forecast === false) {
          this.addChartToList("surprise-analysis");
          this.addChartToList("surprise-line");
        }
      }
    }

    //sortorder of chart names
    if (this.chartMap["Distribution"]) {
      this.sortedChartNames.push("Distribution");
    }
    if (this.chartMap["Trend"]) {
      this.sortedChartNames.push("Trend");
    }
    if (this.chartMap["Revisions by Source"]) {
      this.sortedChartNames.push("Revisions by Source");
    }
    // if (this.chartMap["Revisions vs. Peers"]) {
    //   this.sortedChartNames.push("Revisions vs. Peers");
    // }
    if (this.chartMap["Surprise"]) {
      this.sortedChartNames.push("Surprise");
    }

    if (this.chartType.indexOf("-") !== -1) {
      const obj = this.chartType.split("-");
      this.chartType = obj[0].toLowerCase();
      this.chartSubType = obj[1].toLowerCase();
    }
    this.selectedValue = `${this.chartType.toLowerCase()}-${this.chartSubType.toLowerCase()}`;
    const extraData = {
      period: this.dataToUse.period,
      line_id: this.dataToUse.dapparamId.toString(),
      page_url: window.location.href,
      beginning_state_referrer: this.beginningStateReferrer,
    };
    this.setChartDisplayDetails();
    this.appService.logUserAction(
      {},
      this.dataToUse.ticker,
      this.dataToUse.cut,
      `${this.getFeatureName(this.selectedValue)}`,
      extraData,
      this.dataToUse.source,
      "Chart_Open",
    );
    this.beginningStateReferrer = this.getFeatureName(this.selectedValue);
  }

  addChartToList(chartKey: string) {
    const existingIndex = this.chartCarouselList.findIndex((addedCharts) => {
      return addedCharts.value === chartKey;
    });

    if (existingIndex !== -1) {
      //Ignore duplicate charts
      return;
    }
    let chartTypes: Array<ChartType> = [];
    switch (chartKey) {
      case "distribution-analysis":
        chartTypes = [
          {
            label: "Analysis",
            value: "distribution-analysis",
            visible: true,
          },
        ];
        if (this.chartMap["Distribution"] === undefined) {
          this.chartMap["Distribution"] = [];
        }
        this.chartMap["Distribution"] =
          this.chartMap["Distribution"].concat(chartTypes);
        this.chartCarouselList = this.chartCarouselList.concat(chartTypes);
        break;
      case "distribution-range":
        chartTypes = [
          {
            label: "Range",
            value: "distribution-range",
            visible: true,
          },
        ];

        if (this.chartMap["Distribution"] === undefined) {
          this.chartMap["Distribution"] = [];
        }
        this.chartMap["Distribution"] =
          this.chartMap["Distribution"].concat(chartTypes);
        this.chartCarouselList = this.chartCarouselList.concat(chartTypes);
        break;
      case "trend-bar":
        chartTypes = [
          {
            label: "Bar Chart",
            value: "trend-bar",
            visible: true,
          },
        ];

        if (this.chartMap["Trend"] === undefined) {
          this.chartMap["Trend"] = [];
        }
        this.chartMap["Trend"] = this.chartMap["Trend"].concat(chartTypes);
        this.chartCarouselList = this.chartCarouselList.concat(chartTypes);
        break;
      case "revision-daily":
        chartTypes = [
          {
            label: "Daily - 1 year",
            value: "revision-daily",
            visible: true,
          },
        ];

        if (this.chartMap["Revisions by Source"] === undefined) {
          this.chartMap["Revisions by Source"] = [];
        }
        this.chartMap["Revisions by Source"] =
          this.chartMap["Revisions by Source"].concat(chartTypes);
        this.chartCarouselList = this.chartCarouselList.concat(chartTypes);
        break;
      case "revision-monthly":
        chartTypes = [
          {
            label: "Monthly - 2 year",
            value: "revision-monthly",
            visible: true,
          },
        ];

        if (this.chartMap["Revisions by Source"] === undefined) {
          this.chartMap["Revisions by Source"] = [];
        }
        this.chartMap["Revisions by Source"] =
          this.chartMap["Revisions by Source"].concat(chartTypes);
        this.chartCarouselList = this.chartCarouselList.concat(chartTypes);
        break;
      case "revision-analysis":
        chartTypes = [
          {
            label: "Revision analysis",
            value: "revision-analysis",
            visible: true,
          },
        ];

        if (this.chartMap["Revisions by Source"] === undefined) {
          this.chartMap["Revisions by Source"] = [];
        }
        this.chartMap["Revisions by Source"] =
          this.chartMap["Revisions by Source"].concat(chartTypes);
        this.chartCarouselList = this.chartCarouselList.concat(chartTypes);
        break;
      // case "revision-dailypeers":
      //   chartTypes = [
      //     {
      //       label: "Daily - 1 year",
      //       value: "revision-dailypeers",
      //       visible: true
      //     }
      //   ];

      // if (this.chartMap["Revisions vs. Peers"] === undefined) {
      //   this.chartMap["Revisions vs. Peers"] = [];
      // }
      // this.chartMap["Revisions vs. Peers"] = this.chartMap[
      //   "Revisions vs. Peers"
      // ].concat(chartTypes);
      // this.chartCarouselList = this.chartCarouselList.concat(chartTypes);
      // break;
      // case "revision-monthlypeers":
      //   chartTypes = [
      //     {
      //       label: "Monthly - 2 year",
      //       value: "revision-monthlypeers",
      //       visible: true
      //     }
      //   ];

      //   // if (this.chartMap["Revisions vs. Peers"] === undefined) {
      //   //   this.chartMap["Revisions vs. Peers"] = [];
      //   // }
      //   // this.chartMap["Revisions vs. Peers"] = this.chartMap[
      //   //   "Revisions vs. Peers"
      //   // ].concat(chartTypes);
      //   this.chartCarouselList = this.chartCarouselList.concat(chartTypes);
      //   break;
      case "surprise-analysis":
        chartTypes = [
          {
            label: "Analysis",
            value: "surprise-analysis",
            visible: true,
          },
        ];

        if (this.chartMap["Surprise"] === undefined) {
          this.chartMap["Surprise"] = [];
        }
        this.chartMap["Surprise"] =
          this.chartMap["Surprise"].concat(chartTypes);
        this.chartCarouselList = this.chartCarouselList.concat(chartTypes);
        break;
      case "surprise-line":
        chartTypes = [
          {
            label: "Line",
            value: "surprise-line",
            visible: true,
          },
        ];

        if (this.chartMap["Surprise"] === undefined) {
          this.chartMap["Surprise"] = [];
        }
        this.chartMap["Surprise"] =
          this.chartMap["Surprise"].concat(chartTypes);
        this.chartCarouselList = this.chartCarouselList.concat(chartTypes);
        break;
      default:
        console.error("Invalid chart key");
        break;
    }
  }

  setChartDisplayDetails() {
    if (!this.displayData.tableData) {
      return;
    }
    this.displayPeriod = this.defaultData.period;
    this.displayOtherPeriod = this.defaultData.otherPeriod;
    switch (this.selectedValue) {
      case "trend-bar":
        this.chartSubTypeDisplay = "bar chart";
        this.xData = this.displayData.tableData.Value.x;
        this.startDate = this.xData[0];
        this.endDate = this.xData[this.xData.length - 1];
        this.displayPeriod = `${this.startDate} to ${this.endDate}`;
        break;
      case "distribution-range":
        this.chartSubTypeDisplay = this.chartSubType;
        this.xData = this.displayData.tableData.Value.x;
        this.startDate = this.xData[0];
        this.endDate = this.xData[this.xData.length - 1];
        this.displayPeriod = `${this.startDate} to ${this.endDate}`;
        break;
      case "revision-daily":
        this.chartSubTypeDisplay = "daily - 1 year";
        break;
      case "revision-monthly":
        this.chartSubTypeDisplay = "monthly - 2 year";
        break;
      case "revision-analysis":
        this.chartSubTypeDisplay = "revision analysis";
        break;
      // case "revision-dailypeers":
      //   this.chartSubTypeDisplay = "peers - daily 1 year";
      //   break;
      // case "revision-monthlypeers":
      //   this.chartSubTypeDisplay = "peers - monthly 2 year";
      //   break;
      case "surprise-analysis":
        this.chartSubTypeDisplay = "analysis chart";
        this.displayPeriod = " : VA Actuals Vs Expected (Beat/Miss %)";
        break;
      case "surprise-line":
        this.chartSubTypeDisplay = "line chart";
        this.displayPeriod = " : VA Actuals Vs Expected (Beat/Miss %)";
        break;
      default:
        this.chartSubTypeDisplay = this.chartSubType;
        this.displayPeriod = ` - ${this.displayPeriod}`;
    }
  }

  getFeatureName(selectedVal: string) {
    let featureName = "";
    switch (selectedVal) {
      case "distribution-analysis":
        featureName = "Chart_Distribution_Waterfall";
        break;
      case "distribution-range":
        featureName = "Chart_Distribution_HighLow";
        break;
      case "trend-bar":
        featureName = "Chart_Trends_Bar";
        break;
      case "revision-daily":
        featureName = "Chart_Revisions_Source_DailyLTM";
        break;
      case "revision-monthly":
        featureName = "Chart_Revisions_Source_Monthly2Y";
        break;
      // case "revision-dailypeers":
      //   featureName = "Chart_Revisions_Source_DailyLTM";
      //   break;
      // case "revision-monthlypeers":
      //   featureName = "Chart_Revisions_Peers_Monthly2Y";
      //   break;
      case "revision-analysis":
        featureName = "Chart_Revision_Source_Analysis";
        break;
      case "surprise-analysis":
        featureName = "Chart_Surprise_Analysis";
        break;
      case "surprise-line":
        featureName = "Chart_Surprise_Line";
        break;
      default:
        featureName = "";
    }
    return featureName;
  }
  revisionSourceChange(event) {
    this.dataToUse = {
      ...this.dataToUse,
      selectedRevisionSources: event,
    };
    this.tableData = { ...this.dataToUse, tableData: null };
  }

  surpriseSourceChange(event) {
    this.dataToUse = {
      ...this.dataToUse,
      selectedSurpriseSources: event,
    };
    this.tableData = { ...this.dataToUse, tableData: null };
  }

  maxLimitViolated() {
    this.message.error("Error: You cannot select more than 4 sources.");
  }
  peersChange(event) {
    this.dataToUse = {
      ...this.dataToUse,
      tickerList: event,
    };
    this.tableData = { ...this.dataToUse, tableData: null };
  }
  onChartTypeChange() {
    const obj = this.selectedValue.split("-");
    this.chartType = obj[0];
    this.chartSubType = obj[1];
    const slideIndex = this.chartCarouselList.findIndex((carouselChart) => {
      return carouselChart.value === this.selectedValue;
    });
    this.logSwitch = true;
    this.chartCarousel.goTo(Number(slideIndex));
  }
  carouselChange(index) {
    if (index >= this.chartCarouselList.length) {
      index = 0;
    }
    if (index < 0) {
      index = this.chartCarouselList.length - 1;
    }
    this.selectedValue = this.chartCarouselList[index].value;
    this.defaultData.showRevisionSourceList = false;
    this.defaultData.showSurpriseSourceList = false;
    if (
      !this.dataToUse.isValuationRatio &&
      this.dataToUse.sourceList &&
      this.dataToUse.revisionSourceList.list.length > 1 &&
      (this.selectedValue === "revision-daily" ||
        this.selectedValue === "revision-monthly")
    ) {
      this.defaultData.showRevisionSourceList = true;
    } else if (
      !this.dataToUse.isValuationRatio &&
      this.dataToUse.sourceList &&
      this.dataToUse.surpriseSourceList.list.length > 1 &&
      (this.selectedValue === "surprise-analysis" ||
        this.selectedValue === "surprise-line")
    ) {
      this.defaultData.showSurpriseSourceList = true;
    }
    // if (
    //   this.dataToUse.peersList &&
    //   this.dataToUse.peersList.length > 0 &&
    //   (this.selectedValue === "revision-dailypeers" ||
    //     this.selectedValue === "revision-monthlypeers")
    // ) {
    //   this.defaultData.showPeersList =
    //     this.defaultData.peersList &&
    //     this.defaultData.peersList.list &&
    //     this.defaultData.peersList.list.length > 0;
    // } else {
    //   this.defaultData.showPeersList = false;
    // }
    const obj = this.selectedValue.split("-");
    this.chartType = obj[0];
    this.chartSubType = obj[1];
    // flag to distinguish between actual chart switch and false chart switch triggered on component load.
    if (this.logSwitch === true) {
      this.logChartSwitch();
    }
  }

  logChartSwitch() {
    this.logSwitch = false;
    const extraData = {
      period: this.dataToUse.period,
      line_id: this.dataToUse.dapparamId.toString(),
      page_url: window.location.href,
      beginning_state_referrer: this.beginningStateReferrer,
    };
    this.appService.logUserAction(
      {},
      this.dataToUse.ticker,
      this.dataToUse.cut,
      `${this.getFeatureName(this.selectedValue)}`,
      extraData,
      this.dataToUse.source,
      "Chart_Switch",
    );
    this.beginningStateReferrer = this.getFeatureName(this.selectedValue);
  }

  resetPeriod({ from, to }) {
    if (this.chartCarouselList[from].value === "revision-analysis") {
      this.tableData = { ...this.dataToUse, tableData: null };
      this.dataToUse.period = this.orignalPeriod;
      return;
    }
    if (
      this.chartCarouselList[to].value === "revision-analysis" &&
      this.periodSwitch !== ""
    ) {
      this.tableData = { ...this.dataToUse, tableData: null };
      this.dataToUse.period =
        this.periodSwitch === "Q"
          ? this.displayData.firstEstimatedQuarter
          : this.displayData.firstEstimatedPeriod;
      return;
    }

    this.tableData = { ...this.dataToUse, tableData: null };
  }
  prevChart() {
    this.logSwitch = true;
    this.chartCarousel.pre();
  }
  nextChart() {
    this.logSwitch = true;
    this.chartCarousel.next();
  }
  onChangePeriod() {
    switch (this.periodSwitch) {
      case "Q":
        this.dataToUse = {
          ...this.dataToUse,
          period: this.displayData.firstEstimatedQuarter,
        };
        break;
      case "Y":
        this.dataToUse = {
          ...this.dataToUse,
          period: this.displayData.firstEstimatedPeriod,
        };
        break;
      default:
        break;
    }
    this.tableData = { ...this.dataToUse, tableData: null };
    this.logSwitch = true;
    this.logChartSwitch();
  }
  setDisplayData(data) {
    this.displayData = {
      ...this.displayData,
      ...data,
    };
    this.tableData = { ...this.dataToUse, tableData: data.tableData };

    this.displayDataSet = true;
    this.setChartDisplayDetails();
  }

  /**
   * It sets the stock price revision data emitted from chart plotter
   * @param {{'revision-daily': any, 'revision-monthly': any}} data - stock price daily and monthly data
   */
  setPriceStockData(data) {
    if (data) {
      const dailyRevisionStock = data["revision-daily"]
        ? data["revision-daily"].data
        : undefined;
      const monthlyRevisionStock = data["revision-monthly"]
        ? data["revision-monthly"].data
        : undefined;
      if (dailyRevisionStock) {
        this.stockPriceData = {
          ...this.stockPriceData,
          "revision-daily": {
            ...dailyRevisionStock,
            last_date: dailyRevisionStock.last_date
              ? dayjs(dailyRevisionStock.last_date).format(
                  this.dateFormatPattern,
                )
              : "-",
            year_back_date: dailyRevisionStock.year_back_date
              ? dayjs(dailyRevisionStock.year_back_date).format(
                  this.dateFormatPattern,
                )
              : "-",
          },
        };
      }
      if (monthlyRevisionStock) {
        this.stockPriceData = {
          ...this.stockPriceData,
          "revision-monthly": {
            ...monthlyRevisionStock,
            last_date: monthlyRevisionStock.last_date
              ? dayjs(monthlyRevisionStock.last_date).format(
                  this.dateFormatPattern,
                )
              : "-",
            year_back_date: monthlyRevisionStock.year_back_date
              ? dayjs(monthlyRevisionStock.year_back_date).format(
                  this.dateFormatPattern,
                )
              : "-",
          },
        };
      }
    } else {
      this.stockPriceData = {
        "revision-daily": undefined,
        "revision-monthly": undefined,
      };
    }
  }
  setFocus(event) {
    event.currentTarget.querySelector(".slick-dots-bottom").focus();
  }
  plotSwitch() {
    this.plotType = this.plotType === "Data" ? "Chart" : "Data";
    this.logSwitch = true;
    this.logChartSwitch();
  }
}
